import { unsupported } from '../errors'
import { pagosReal } from '../pagos/real'
import { checkoutGuideItem, realRebook, saveChecked } from './shared'
import type { CheckoutService } from './types'


export const checkoutReal: CheckoutService = {
  // Hora de salida de E1 (`endDate` + `departureTime`, ya en `stay.dates.checkOut`) y total de E2, como la app actual.
  async getCheckout(stay, lang, signal) {
    const summary = await pagosReal.getPaymentSummary(stay, lang, signal)
    return {
      time: stay.dates.checkOut,
      checklist: [],
      instructions: checkoutGuideItem(stay),
      left: false,
      leftAt: null,
      canMarkLeft: false,
      charges: [],
      total: summary.total,
      allPaid: summary.pending.amount === 0,
    }
  },
  setChecklistItem(stay, id, done) {
    saveChecked(stay.guestCode, id, done)
    return Promise.resolve()
  },
  // Sin endpoint: guardarlo en el dispositivo no avisaría a la propiedad (D52).
  markLeft: unsupported,
  // Reseña, descuento, fechas y fidelización no existen en la API actual (D36): solo el enlace de volver a reservar.
  getAfterStay(stay) {
    return Promise.resolve({ review: null, rebook: realRebook(stay), loyalty: null })
  },
}
